import script from "./BaziPredictionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaziPredictionForm.vue?vue&type=script&setup=true&lang=ts"

import "./BaziPredictionForm.vue?vue&type=style&index=0&id=1646314a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1646314a"]])

export default __exports__